module.exports = __webpack_public_path__ + "img/51626521_L.8b924cb0.png";